/**
 * Filter chips — single-select pill row used by all compact list pages.
 *
 * Why a separate file: the parent list pages have to stay flat for the
 * visual-edits Babel plugin (member.expression.map() in JSX crashes it),
 * so we isolate the iteration here.
 */
import React from 'react';

const FilterChips = ({ chips, value, onChange, testidPrefix = 'filter-chip' }) => (
  <div className="inline-flex flex-wrap gap-1.5" data-testid={`${testidPrefix}-row`}>
    {chips.map((c) => {
      const active = c.value === value;
      return (
        <button
          key={c.value}
          type="button"
          onClick={() => onChange(c.value)}
          data-testid={`${testidPrefix}-${c.value}`}
          className={`text-xs px-2.5 py-1 rounded-full transition-colors ${
            active
              ? 'bg-emerald-600 text-white border border-emerald-600'
              : 'bg-white text-slate-600 border border-slate-200 hover:border-slate-300'
          }`}
        >
          {c.label}
          {typeof c.count === 'number' ? (
            <span className={`ml-1 font-mono ${active ? 'opacity-90' : 'text-slate-400'}`}>
              {c.count}
            </span>
          ) : null}
        </button>
      );
    })}
  </div>
);

export default FilterChips;
